import React from "react";
import { Button, Grid, Link } from "@mui/material";
import {
  BodyTypography,
  BulletPoint,
  BulletedList,
  HeaderTypography,
  OrderedList,
  OrderedListItem,
} from "./Typography";

const Datenschutz = () => {
  return (
    <Grid container flexDirection="column" alignItems="flex-start">
      <BodyTypography>
        Die TÜV Rheinland Consulting GmbH freut sich sehr über Ihren Besuch auf
        unserer Website und Ihrem Interesse an unseren Dienstleistungen und
        Fachbeiträgen. Datenschutz und Datensicherheit für unsere Nutzer:innen
        haben seit jeher eine hohe Bedeutung. Der Schutz Ihrer personenbezogenen
        Daten ist daher sehr wichtig und für uns ein besonderes Anliegen. Seit
        dem 25. Mai 2018 gelten im Bereich Datenschutz europaweit die
        einheitlichen Vorgaben der EU-Datenschutz-Grundverordnung (DSGVO).
        Nachfolgend möchten wir Sie über die durch die TÜV Rheinland Consulting
        GmbH („TRC“ und/oder „wir“ und/oder „Verantwortliche“) durchgeführte
        Verarbeitung personenbezogener Daten nach Maßgabe des Art. 13 DSGVO
        hinweisen.
      </BodyTypography>
      <HeaderTypography>Inhaltsübersicht</HeaderTypography>
      <BulletedList>
        <BulletPoint>Allgemeine Hinweise und Pflichtinformationen</BulletPoint>
        <BulletPoint>
          Informationen über die Erhebung personenbezogener Daten
        </BulletPoint>
        <BulletPoint>
          Ihre Rechte Erhebung personenbezogener Daten bei Besuch unserer
          Website
        </BulletPoint>
        <BulletPoint>
          Cookie Deklaration und Änderungsmöglichkeit Ihrer Einwilligung zur
          Nutzung von Cookies
        </BulletPoint>
        <BulletPoint>
          Weitere Funktionen und Angebote unserer Website
        </BulletPoint>
        <BulletPoint>
          Widerspruch oder Widerruf gegen die Verarbeitung Ihrer Daten
        </BulletPoint>
        <BulletPoint>Analyse Tools</BulletPoint>
      </BulletedList>
      <HeaderTypography>
        Allgemeine Hinweise und Pflichtinformationen
      </HeaderTypography>
      <BodyTypography>
        Die Datenschutzerklärung gibt Ihnen einen Überblick darüber, welche
        Daten die TRC erfasst und was mit Ihren personenbezogene Daten passiert,
        wenn Sie unsere Webseiten besuchen. Wir behandeln Ihre personenbezogenen
        Daten vertraulich und entsprechend der gesetzlichen
        Datenschutzvorschriften sowie nach dieser Datenschutzerklärung. Beim
        Besuch unserer Website kann Ihr Surf-Verhalten statistisch ausgewertet
        werden. Das geschieht vor allem mit Cookies und mit Analyse-Tools und
        Tools von Drittanbietern. Die Analyse Ihres Surf-Verhaltens erfolgt in
        der Regel anonym; das Surf-Verhalten kann nicht zu Ihnen zurückverfolgt
        werden. Sie können dieser Analyse widersprechen oder sie durch die
        Nichtbenutzung bestimmter Tools verhindern. Detaillierte Informationen
        dazu finden Sie in den folgenden Hinweisen unserer Datenschutzerklärung.
      </BodyTypography>
      <HeaderTypography>
        Information über die Erhebung personenbezogener Daten
      </HeaderTypography>
      <OrderedList>
        <OrderedListItem>
          Im Folgenden informieren wir über die Erhebung und weitere
          Verarbeitung personenbezogener Daten bei Nutzung unserer Website.
          Personenbezogene Daten sind alle Daten, die auf Sie persönlich
          beziehbar sind oder mit denen Sie persönlich identifiziert werden
          können, z. B. Name, Adresse, E-Mail-Adressen, Nutzerverhalten.
        </OrderedListItem>
        <OrderedListItem>
          Die Verantwortliche gemäß Art. 4 Abs. 7 EU-Datenschutz-Grundverordnung
          (DSGVO) ist TÜV Rheinland Consulting GmbHTillystraße 290431 Nürnberg
          vertreten durch die Geschäftsführer Mariusz C. Bodek und Gunnar Franke
          Tel: +49 221 806 1950Fax: +49 221 806 3496E-Mail:
          consulting@de.tuv.com für die Website: consulting.tuv.com.
        </OrderedListItem>
        <OrderedListItem>
          Unsere gesetzlich vorgeschriebene
          Da&shy;ten&shy;schutz&shy;be&shy;auf&shy;trag&shy;te erreichen Sie
          unter:
          <OrderedList>
            <OrderedListItem>
              consulting@de.tuv.com mit dem Betreff
              „Da&shy;ten&shy;schutz&shy;be&shy;auf&shy;trag&shy;te“
            </OrderedListItem>

            <OrderedListItem>
              oder unserer Postadresse mit dem Zusatz
              „Da&shy;ten&shy;schutz&shy;be&shy;auf&shy;trag&shy;te“.
            </OrderedListItem>
          </OrderedList>
        </OrderedListItem>
        <OrderedListItem>
          Bei Ihrer Kontaktaufnahme mit uns per E-Mail oder über ein
          Kontaktformular werden die von Ihnen mitgeteilten Daten (Ihre
          E-Mail-Adresse, ggf. Ihr Name und Ihre Telefonnummer) von uns
          gespeichert, um Ihre Fragen zu beantworten. Die in diesem Zusammenhang
          anfallenden Daten löschen wir, nachdem die Speicherung nicht mehr
          erforderlich ist, oder schränken die Verarbeitung ein, falls
          gesetzliche Aufbewahrungspflichten bestehen.
        </OrderedListItem>
        <OrderedListItem>
          Falls wir für einzelne Funktionen unseres Angebots auf beauftragte
          Dienstleister zurückgreifen oder Ihre Daten für werbliche Zwecke
          nutzen möchten, werden wir Sie untenstehend im Detail über die
          jeweiligen Vorgänge informieren. Dabei nennen wir auch die
          festgelegten Kriterien der Speicherdauer.
        </OrderedListItem>
        <OrderedListItem>
          Sofern Ihre Anfrage eine Übermittlung personenbezogener Daten an
          bestimmte Empfänger erforderlich macht, werden die Daten auch an
          Dritte weitergegeben. Dies erfolgt stets im Rahmen der gesetzlichen
          Bestimmungen.
        </OrderedListItem>
        <OrderedListItem>
          Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der
          Übertragung vertraulicher Inhalte, wie zum Beispiel versendete
          Formulareingaben eine SSL- bzw. TLS-Verschlüsselung. Ist die
          Verschlüsselung aktiviert, können die an uns übermittelten Daten nicht
          von Dritten mitgelesen werden. Eine verschlüsselte Verbindung erkennen
          Sie daran, dass die Adresszeile des Browsers von “http://” auf
          “https://” wechselt und an dem Schloss-Symbol in Ihrer Browserzeile.
        </OrderedListItem>
        <OrderedListItem>
          Der Nutzung von im Rahmen der Impressumspflicht veröffentlichten
          Kontaktdaten zur Übersendung von nicht ausdrücklich angeforderter
          Werbung und Informationsmaterialien wird hiermit widersprochen. Die
          Betreiber der Seiten behalten sich ausdrücklich rechtliche Schritte im
          Falle der unverlangten Zusendung von Werbeinformationen, etwa durch
          Spam-E-Mails, vor.
        </OrderedListItem>
      </OrderedList>
      <HeaderTypography>Ihre Rechte</HeaderTypography>
      <OrderedList>
        <OrderedListItem>
          Sie haben gegenüber uns folgende Rechte hinsichtlich der Sie
          betreffenden personenbezogenen Daten:
          <OrderedList>
            <OrderedListItem>Recht auf Auskunft</OrderedListItem>
            <OrderedListItem>
              Recht auf Berichtigung oder Löschung
            </OrderedListItem>
            <OrderedListItem>
              Recht auf Einschränkung der Verarbeitung
            </OrderedListItem>
            <OrderedListItem>
              Recht auf Widerspruch gegen die Verarbeitung
            </OrderedListItem>
            <OrderedListItem> Recht auf Datenübertragbarkeit.</OrderedListItem>
          </OrderedList>
        </OrderedListItem>
        <OrderedListItem>
          Sie haben zudem das Recht, sich bei einer Datenschutz-Aufsichtsbehörde
          über die Verarbeitung Ihrer personenbezogenen Daten durch uns zu
          beschweren.
        </OrderedListItem>
      </OrderedList>
      <HeaderTypography>
        Erhebung personenbezogener Daten bei Besuch unserer Website
      </HeaderTypography>
      <OrderedList>
        <OrderedListItem>
          Bei der bloß informatorischen Nutzung der Website, also, wenn Sie sich
          nicht registrieren oder uns anderweitig Informationen übermitteln,
          erheben wir bereits die folgenden personenbezogenen Daten, die Ihr
          Browser an unseren Server übermittelt:
          <OrderedList>
            <OrderedListItem>IP-Adresse</OrderedListItem>
            <OrderedListItem>Datum und Uhrzeit der Anfrage</OrderedListItem>
            <OrderedListItem>
              Zeitzonendifferenz zur Greenwich Mean Time (GMT)
            </OrderedListItem>
            <OrderedListItem>
              Inhalt der Anforderung (konkrete Seite)
            </OrderedListItem>
            <OrderedListItem> Zugriffsstatus/HTTP-Statuscode</OrderedListItem>
            <OrderedListItem>jeweils übertragene Datenmenge</OrderedListItem>
            <OrderedListItem>
              Website, von der die Anforderung kommt
            </OrderedListItem>
            <OrderedListItem> Browser</OrderedListItem>
            <OrderedListItem>
              Betriebssystem und dessen Oberfläche
            </OrderedListItem>
            <OrderedListItem>
              Sprache und Version der Browsersoftware
            </OrderedListItem>
          </OrderedList>
          Grundlage für die Datenverarbeitung ist Art. 6 Abs. 1 lit. f DSGVO,
          der die Verarbeitung von technisch erforderlichen Daten, die einen
          stabilen und sicheren Betrieb der Webseite gewährleisten, gestattet.
        </OrderedListItem>
        <OrderedListItem>
          Zusätzlich zu den zuvor genannten Daten werden bei Ihrer Nutzung
          unserer Website Cookies auf Ihrem Rechner gespeichert. Bei Cookies
          handelt es sich um kleine Textdateien, die auf Ihrer Festplatte dem
          von Ihnen verwendeten Browser zugeordnet gespeichert werden und durch
          welche der Stelle, die den Cookie setzt (hier durch uns), bestimmte
          Informationen zufließen. Cookies können keine Programme ausführen oder
          Viren auf Ihren Computer übertragen. Sie dienen dazu, das
          Internetangebot insgesamt nutzerfreundlicher und effektiver zu machen.
        </OrderedListItem>
        <OrderedListItem>
          Einsatz von Cookies:
          <OrderedList>
            <OrderedListItem>
              Diese Website nutzt folgende Arten von Cookies, deren Umfang und
              Funktionsweise im Folgenden erläutert werden:
              <OrderedList>
                <OrderedListItem>Transiente Cookies</OrderedListItem>
                <OrderedListItem>Persistente Cookies</OrderedListItem>
              </OrderedList>
            </OrderedListItem>
            <OrderedListItem>
              Transiente Cookies werden automatisiert gelöscht, wenn Sie den
              Browser schließen. Dazu zählen insbesondere die Session-Cookies.
              Diese speichern eine sogenannte Session-ID, mit welcher sich
              verschiedene Anfragen Ihres Browsers der gemeinsamen Sitzung
              zuordnen lassen. Dadurch kann Ihr Rechner wiedererkannt werden,
              wenn Sie auf unsere Website zurückkehren. Die Session-Cookies
              werden gelöscht, wenn Sie sich ausloggen oder den Browser
              schließen.
            </OrderedListItem>
            <OrderedListItem>
              Persistent Cookies werden automatisiert nach einer vorgegebenen
              Dauer gelöscht, die sich je nach Cookie unterscheiden kann. Sie
              können die Cookies in den Sicherheitseinstellungen Ihres Browsers
              jederzeit löschen.
            </OrderedListItem>
            <OrderedListItem>
              Sie können Ihre Browser-Einstellung entsprechend Ihren Wünschen
              konfigurieren und z.B. die Annahme von Third-Party-Cookies oder
              allen Cookies ablehnen. Wir weisen Sie darauf hin, dass Sie
              eventuell nicht alle Funktionen dieser Website nutzen können.
            </OrderedListItem>
          </OrderedList>
        </OrderedListItem>
        <OrderedListItem>
          Grundlage für die Datenverarbeitung ist auch hier Art. 6 Abs. 1 lit. f
          DSGVO (z.B zum fehlerfreien Betrieb der Webseiten). Soweit andere
          Cookies (z.B. Cookies zur Analyse Ihres Surfverhaltens) gespeichert
          werden, werden diese Cookies in unserer Datenschutzerklärung gesondert
          behandelt.Grundlage für die Datenverarbeitung ist auch hier Art. 6
          Abs. 1 lit. f DSGVO (z.B zum fehlerfreien Betrieb der Webseiten).
          Soweit andere Cookies (z.B. Cookies zur Analyse Ihres Surfverhaltens)
          gespeichert werden, werden diese Cookies in unserer
          Datenschutzerklärung gesondert behandelt.
        </OrderedListItem>
      </OrderedList>
      <HeaderTypography>
        Cookie Deklaration und Änderungsmöglichkeit Ihrer Einwilligung zur
        Nutzung von Cookies
      </HeaderTypography>
      <BodyTypography>
        Auch wir verwenden Cookies! Wir verwenden Cookies, um Ihnen das
        bestmögliche Erlebnis auf unserer Website zu ermöglichen. Klicken Sie
        auf „Alle Cookies akzeptieren“, stimmen Sie der Speicherung aller
        Cookies auf Ihrem Gerät zu. Technisch erforderliche Cookies müssen
        gesetzt werden, um den einwandfreien Betrieb unserer Website zu
        gewährleisten. Sie können frei entscheiden welche weiteren Kategorien
        Sie zulassen möchten indem unten Sie auf den Link Cookie Einstellungen
        klicken. Bitte beachten Sie, dass je nach den von Ihnen gewählten
        Einstellungen die volle Funktionalität der Website möglicherweise nicht
        mehr zur Verfügung steht. Weitere Informationen sowie die Möglichkeit,
        Ihre Einwilligung in das Setzen von Cookies zu widerrufen finden Sie in
        unserer Datenschutzerklärung. Cookies sind kleine Textdateien, die von
        Webseiten verwendet werden, um die Benutzererfahrung effizienter zu
        gestalten.
      </BodyTypography>
      <BodyTypography>
        Laut Gesetz können wir Cookies auf Ihrem Gerät speichern, wenn diese für
        den Betrieb dieser Seite unbedingt notwendig sind. Für alle anderen
        Cookie-Typen benötigen wir Ihre Erlaubnis.
      </BodyTypography>
      <BodyTypography>
        Diese Seite verwendet unterschiedliche Cookie-Typen. Einige Cookies
        werden von Drittparteien platziert, die auf unseren Seiten erscheinen.
        Sie können Ihre Einwilligung jederzeit von der Cookie-Erklärung auf
        unserer Website ändern oder widerrufen.
      </BodyTypography>
      <BodyTypography>
        Erfahren Sie in unserer Datenschutzrichtlinie mehr darüber, wer wir
        sind, wie Sie uns kontaktieren können und wie wir personenbezogene Daten
        verarbeiten. Bitte geben Sie Ihre Einwilligungs-ID und das Datum an,
        wenn Sie uns bezüglich Ihrer Einwilligung kontaktieren. Ihre
        Einwilligung trifft auf die folgenden Domains zu: consulting.tuv.com
      </BodyTypography>
      <Grid item alignSelf="center">
        <Button variant="outlined" sx={{ m: 1.5 }}>
          Cookie-Einstellungen anzeigen
        </Button>
      </Grid>
      <HeaderTypography>
        Weitere Funktionen und Angebote unserer Website
      </HeaderTypography>
      <OrderedList>
        <OrderedListItem>
          Neben der rein informatorischen Nutzung unserer Website bieten wir
          verschiedene Leistungen an, die Sie bei Interesse nutzen können. Dazu
          müssen Sie in der Regel weitere personenbezogene Daten angeben, die
          wir zur Erbringung der jeweiligen Leistung nutzen und für die die
          zuvor genannten Grundsätze zur Datenverarbeitung gelten.
        </OrderedListItem>
        <OrderedListItem>
          Teilweise bedienen wir uns zur Verarbeitung Ihrer Daten externer
          Dienstleister. Diese wurden von uns sorgfältig ausgewählt und
          beauftragt, sind an unsere Weisungen gebunden und werden regelmäßig
          kontrolliert.
        </OrderedListItem>
        <OrderedListItem>
          Weiterhin können wir Ihre personenbezogenen Daten an Dritte
          weitergeben, wenn Aktionsteilnahmen, Gewinnspiele, Vertragsabschlüsse
          oder ähnliche Leistungen von uns gemeinsam mit Partnern angeboten
          werden. Nähere Informationen hierzu erhalten Sie bei Angabe Ihrer
          personenbezogenen Daten oder untenstehend in der Beschreibung des
          Angebotes.
        </OrderedListItem>
        <OrderedListItem>
          Soweit unsere Dienstleister oder Partner ihren Sitz in einem Staat
          außerhalb des Europäischen Wirtschaftsraumen (EWR) haben, informieren
          wir Sie über die Folgen dieses Umstands in der Beschreibung des
          Angebotes.
        </OrderedListItem>
      </OrderedList>
      <HeaderTypography>
        Widerspruch oder Widerruf gegen die Verarbeitung Ihrer Daten
      </HeaderTypography>
      <OrderedList>
        <OrderedListItem>
          Falls Sie eine Einwilligung zur Verarbeitung Ihrer Daten erteilt
          haben, können Sie diese jederzeit widerrufen. Ein solcher Widerruf
          beeinflusst die Zulässigkeit der Verarbeitung Ihrer personenbezogenen
          Daten, nachdem Sie ihn gegenüber uns ausgesprochen haben.
        </OrderedListItem>
        <OrderedListItem>
          Soweit wir die Verarbeitung Ihrer personenbezogenen Daten auf die
          Interessenabwägung stützen, können Sie Widerspruch gegen die
          Verarbeitung einlegen. Dies ist der Fall, wenn die Verarbeitung
          insbesondere nicht zur Erfüllung eines Vertrags mit Ihnen erforderlich
          ist, was von uns jeweils bei der nachfolgenden Beschreibung der
          Funktionen dargestellt wird. Bei Ausübung eines solchen Widerspruchs
          bitten wir um Darlegung der Gründe, weshalb wir Ihre personenbezogenen
          Daten nicht wie von uns durchgeführt verarbeiten sollten. Im Falle
          Ihres begründeten Widerspruchs prüfen wir die Sachlage und werden
          entweder die Datenverarbeitung einstellen bzw. anpassen oder Ihnen
          unsere zwingenden schutzwürdigen Gründe aufzeigen, aufgrund derer wir
          die Verarbeitung fortführen.
        </OrderedListItem>
        <OrderedListItem>
          Selbstverständlich können Sie der Verarbeitung Ihrer personenbezogenen
          Daten für Zwecke der Werbung und Datenanalyse jederzeit widersprechen.
          Über Ihren Werbewiderspruch können Sie uns unter folgenden
          Kontaktdaten informieren: Über E-Mail an{" "}
          <Link href="mailto:consulting@de.tuv.com">consulting@de.tuv.com</Link>{" "}
          oder per Post an TÜV Rheinland Consulting GmbH, Am Grauen Stein, 51105
          Köln.
        </OrderedListItem>
      </OrderedList>
      <HeaderTypography>Analyse-Tools</HeaderTypography>
    </Grid>
  );
};

export default Datenschutz;
